import { render, staticRenderFns } from "./diet-challenge.vue?vue&type=template&id=49ba161e&"
import script from "./diet-challenge.vue?vue&type=script&lang=js&"
export * from "./diet-challenge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CButton: require('@chakra-ui/vue').CButton, CFlex: require('@chakra-ui/vue').CFlex, CImage: require('@chakra-ui/vue').CImage, CHeading: require('@chakra-ui/vue').CHeading, CBox: require('@chakra-ui/vue').CBox, CBadge: require('@chakra-ui/vue').CBadge, CText: require('@chakra-ui/vue').CText, CIcon: require('@chakra-ui/vue').CIcon})
